import { SchemaDefinition } from "../validator/schema-definition-interface";

/**
 * The schema definition for the stored signature entry object.
 */
export const storedSignatureEntrySchema: SchemaDefinition = {
	Name: 'stored-signature-entry',
	Properties: {
		Signature: { Type: 'object' },
		Timestamp: { Type: 'Date' }
	}
}